import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

// Función para formatear la fecha en formato dd/mm/yyyy
const formatearFecha = (fechaStr) => {
  const fecha = new Date(fechaStr);
  return fecha.toLocaleDateString('es-CO', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

const ListarActasPorGrupo = ({ refresh }) => {
  const [actas, setActas] = useState([]);
  const { id } = useParams(); // Captura el ID del grupo desde la URL

  const navigate = useNavigate();

  const generarYDescargarActa = async (idActa, fichaGrupo, numeroActa) => {
    try {
      const response = await axios.get(`/api/actas/generar-docx/${idActa}`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Acta_${fichaGrupo}_${numeroActa}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al generar el acta:', error.message);
      Swal.fire('Error', 'No se pudo generar el acta.', 'error');
    }
  };

  const getData = useCallback(async () => {
  try {
    const response = await axios.get(`/api/grupos/actas/listidgrupo/${id}`);

    if (response.data && response.data.ok && Array.isArray(response.data.actas)) {
      const actasConFunciones = response.data.actas.map((acta) => ({
        ...acta,
        fecha: formatearFecha(acta.fecha),
        funciones: (
          <div className="d-flex gap-2">
            <button
              className="btn btn-warning"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => navigate(`/institucional/grupos/actas/editar/${acta._id}`)}
            >
              <i className="fa-solid fa-pen-to-square"></i>
            </button>
            <button
              className="btn btn-success"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => generarYDescargarActa(acta._id, acta.fichaGrupo, acta.numeroActa)}
              title="Descargar Acta"
            >
              <i className="fa-solid fa-file-word fa-lg text-white"></i>
            </button>
            <button
              className="btn btn-danger"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => deleteActa(acta._id)}
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </div>
        ),
      }));
      setActas(actasConFunciones.reverse());
    } else {
      setActas([]);
      console.warn('No se encontraron actas.');
    }
  } catch (error) {
    console.error('Error al cargar las actas:', error.message);
  }
  // eslint-disable-next-line 
}, [id, navigate]); // Added missing dependencies here

  useEffect(() => {
    if (id) getData();
  }, [id, getData, refresh]);


  const deleteActa = async (idActa) => {
    try {
      const confirm = await Swal.fire({
        title: '¿Está seguro?',
        text: '¡Esta acción no se puede deshacer!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
      });

      if (confirm.isConfirmed) {
        const { data } = await axios.delete(`/api/grupos/actas/delete/${idActa}`);
        setActas(prevActas => prevActas.filter(acta => acta._id !== idActa));
        Swal.fire({
          icon: 'success',
          title: data.message || 'Acta eliminada',
          showConfirmButton: false,
          timer: 1500,
        });
        getData();
      }
    } catch (error) {
      console.error('Error al eliminar el acta:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el acta.', 'error');
    }
  };

  const columns = React.useMemo(() => [
    { Header: 'N° Acta', accessor: 'numeroActa' },
    { Header: 'Comité o Reunión', accessor: 'nombreComiteReunion' },
    { Header: 'Ciudad', accessor: 'ciudad' },
    { Header: 'Fecha', accessor: 'fecha' },
    { accessor: 'funciones' },
  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">

      <div className="d-flex align-items-center mb-3">
        <button
          style={{ marginTop: '24px', marginLeft: '32px' }}
          className="btn btn-outline-dark rounded-pill shadow-sm px-3 d-flex align-items-center gap-2 me-3"
          onClick={() => navigate(-1)}
          title="Regresar"
        >

          <i className="fa-solid fa-arrow-rotate-left"></i>
          <span>Volver</span>
        </button>

        <h1 className="text-center flex-grow-1 m-0">Lista de Actas del Grupo</h1>
      </div>

      {actas.length > 0 ? (
        <DataTable columns={columns} data={actas} />
      ) : (
        <p className="text-muted">No hay actas disponibles para este grupo.</p>
      )}
    </div>
  );
};

export default ListarActasPorGrupo;
